<template>
<div class="pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5"  :key="componentKey">
  <loading v-if="loadingState" />

  <!--  PAYMENT KO ******************************************************************************************************************** -->
  <div v-if="!payment && loaded" class="container  mt-5 mb-5 pb-5 pt-4">

    <!--   HEADER TITLE    ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
    <div class="row justify-content-center text-left">
      <h3 class="Regular center h0 widthFull"><b>Pratica N. {{item.code}} </b></h3>

      <div class="col-md-8 center mb-3 text-left">
        <h4 class="Regular text-left h0 widthFull "><b> Per completare la tua pratica, paga il servizio con una Carta o PayPal </b></h4>
        <p class="black mt-0 text-left widthFull ">
          Il prezzo è riferito ad una pratica. A pagamento avvenuto potrai caricare i documenti richiesti e completare la pratica.
        </p>

      </div>
      <div class="col-md-4 pt-md-4 center mb-3 text-right">
        <router-link :to="{ name: 'pratiche'}" class="btn btn-primary m-2 btn-sm ml-md-5">
          <font-awesome-icon icon="arrow-left" size="1x" />
          Indietro
        </router-link>
      </div>

    </div>


    <div class="row justify-content-center text-left">
      <div  class="col-md-12 pb-0 buyPlan center">
        <h3 class="center darkBlue mb-3">  </b></h3>
        <div class="widthFull" v-if="!paySuccess">
          <div class="row ">

            <div class="col-sm-6 col-md-6 col-lg-6 text-left bgWhite">

              <div class="row ">
                <div class="col-md-8 text-left">
                  <h5 class=" text-left mb-0">  Prezzo Servizio/Pratica (IVA Esclusa)  </h5>
                </div>
                <div class="col-md-3 text-right">
                  <h5 class=" text-right mb-0"><b class="">{{buyPlan.price | formatNumber}} € </b></h5>
                </div>
              </div>

              <div class="row ">
                <div class="col-md-8 text-left">
                  <h5 class=" text-left mb-4">  IVA 22%  </h5>
                </div>
                <div class="col-md-3 text-right">
                  <h5 class=" text-right mb-4">  <b class="">{{buyPlan.iva | formatNumber}} € </b></h5>
                </div>
              </div>

              <!-- PRATICA ENEA -->
              <div v-if="item.enea_request  != '0'" class="row ">
                <div class="col-md-8 text-left borderTopBlack">
                  <h5 class=" text-left mb-0">Prezzo  Servizio di redazione e invio pratica ENEA (IVA Esclusa)  </h5>
                </div>
                <div class="col-md-3 text-right">
                  <h5 class=" text-right mb-0"><b class="">{{buyPlan.priceEnea | formatNumber}} € </b></h5>
                </div>
              </div>

              <div v-if="item.enea_request  != '0' "  class="row ">
                <div class="col-md-8 text-left">
                  <h5 class=" text-left mb-4">  IVA 22%  </h5>
                </div>
                <div class="col-md-3 text-right">
                  <h5 class=" text-right mb-4">  <b class="">{{buyPlan.ivaEnea | formatNumber}} € </b></h5>
                </div>
              </div>

              <!-- DATI CATASTALI -->
              <div v-if="item.to_get_cadastral_data != '0' " class="row ">
                <div class="col-md-8 text-left borderTopBlack">
                  <h5 class=" text-left mb-0">  Prezzo Servizio "Visura Catastale" (IVA Esclusa)  </h5>
                </div>
                <div class="col-md-3 text-right">
                  <h5 class=" text-right mb-0"><b class="">{{buyPlan.priceDcast | formatNumber}} € </b></h5>
                </div>
              </div>

              <div v-if="item.to_get_cadastral_data  != '0' "  class="row ">
                <div class="col-md-8 text-left">
                  <h5 class=" text-left mb-4">  IVA 22%  </h5>
                </div>
                <div class="col-md-3 text-right">
                  <h5 class=" text-right mb-4">  <b class="">{{buyPlan.ivaDcast | formatNumber}} € </b></h5>
                </div>
              </div>


              <div class="row ">
                <div class="col-md-8 borderTopBlack text-left">
                  <h5 class=" text-right mb-4">
                    TOTALE (IVA inclusa)
                  </h5>
                </div>

                <div class="col-md-3 text-right borderTopBlack">
                  <h5 class=" text-right mb-4">
                    <!-- CLASSIC -->
                    <b class="" v-if="item.enea_request == '0' && item.to_get_cadastral_data == '0'">{{buyPlan.amount | formatNumber}} € </b>
                    <!-- CLASSIC + ENEA -->
                    <b class="" v-if="item.enea_request != '0' && item.to_get_cadastral_data == '0'">{{buyPlan.amount_enea | formatNumber}} € </b>
                    <!-- CLASSIC + DCAST -->
                    <b class="" v-if="item.enea_request == '0' && item.to_get_cadastral_data != '0'">{{buyPlan.amount_dcast | formatNumber}} € </b>
                    <!-- CLASSIC + ENEA + DCAST -->
                    <b class="" v-if="item.enea_request != '0' && item.to_get_cadastral_data != '0'">{{buyPlan.amount_enea_dcast | formatNumber}} € </b>

                  </h5>
                </div>

              </div>

            </div>
            <div class="col-sm-0 col-md-1 col-lg-1 text-left"></div>
            <div class="col-sm-6 col-md-6 col-lg-4">
              <h2 class="center widthFull mb-3 mt-3 bgWhite pb-3">
              <h3 class="center  mb-3 mt-0 pt-3"><b>Paga con</b></h3>
              <img class="img-fluid widthFull payImage mb-2" src="../../assets/images/paypal1.png">

                <!-- CLASSIC -->
                <paypal-checkout v-if="item.enea_request == '0' && item.to_get_cadastral_data == '0'"  :env="envPP" :amount="'' + buyPlan.amount" :invoice-number="'CHEBONUS_PRATICA_' + item.code"
                :items="[{'name': 'CHEBONUS-' + item.code,'description': 'PRATICA_' + item.code, 'price': '' + buyPlan.amount, 'quantity': '1', 'currency': 'EUR'}]"
                currency="EUR" locale="it_IT" :client="credentials" :button-style="{size:'large'}" :experience="experienceOptions"
                  v-on:payment-authorized="paymentAuthorized" v-on:payment-completed="paymentCompleted" v-on:payment-cancelled="paymentCancelled">
                </paypal-checkout>

                <!-- CLASSIC + ENEA -->
                <paypal-checkout v-if="item.enea_request != '0' && item.to_get_cadastral_data == '0'"  :env="envPP" :amount="'' + buyPlan.amount_enea" :invoice-number="'CHEBONUS_PRATICA_' + item.code"
                :items="[
                {'name': 'CHEBONUS-' + item.code,'description': 'PRATICA_' + item.code, 'price': '' + buyPlan.amount, 'quantity': '1', 'currency': 'EUR'},
                {'name': 'Pratica ENEA','description': 'Servizio di redazione e invio pratica ENEA', 'price': '' + buyPlan.priceEnea * 1.22, 'quantity': '1', 'currency': 'EUR'}]"
                currency="EUR" locale="it_IT" :client="credentials" :button-style="{size:'large'}" :experience="experienceOptions"
                  v-on:payment-authorized="paymentAuthorized" v-on:payment-completed="paymentCompleted" v-on:payment-cancelled="paymentCancelled">
                </paypal-checkout>

                <!-- CLASSIC + DCAST -->
                <paypal-checkout v-if="item.enea_request == '0' && item.to_get_cadastral_data != '0'"  :env="envPP" :amount="'' + buyPlan.amount_dcast" :invoice-number="'CHEBONUS_PRATICA_' + item.code"
                :items="[
                {'name': 'CHEBONUS-' + item.code,'description': 'PRATICA_' + item.code, 'price': '' + buyPlan.amount, 'quantity': '1', 'currency': 'EUR'},
                {'name': 'Visura Catastale','description': 'Servizio Visura Catastale', 'price': '' + buyPlan.priceDcast * 1.22, 'quantity': '1', 'currency': 'EUR'}]"
                currency="EUR" locale="it_IT" :client="credentials" :button-style="{size:'large'}" :experience="experienceOptions"
                  v-on:payment-authorized="paymentAuthorized" v-on:payment-completed="paymentCompleted" v-on:payment-cancelled="paymentCancelled">
                </paypal-checkout>

                <!-- CLASSIC + ENEA + DCAST -->
                <paypal-checkout v-if="item.enea_request != '0' && item.to_get_cadastral_data != '0'"  :env="envPP" :amount="'' + buyPlan.amount_enea_dcast" :invoice-number="'CHEBONUS_PRATICA_' + item.code"
                :items="[
                {'name': 'CHEBONUS-' + item.code,'description': 'PRATICA_' + item.code, 'price': '' + buyPlan.amount, 'quantity': '1', 'currency': 'EUR'},
                {'name': 'Pratica ENEA','description': 'Servizio di redazione e invio pratica ENEA', 'price': '' + buyPlan.priceEnea * 1.22, 'quantity': '1', 'currency': 'EUR'},
                {'name': 'Visura Catastale','description': 'Servizio Visura Catastale', 'price': '' + buyPlan.priceDcast * 1.22, 'quantity': '1', 'currency': 'EUR'}]"
                currency="EUR" locale="it_IT" :client="credentials" :button-style="{size:'large'}" :experience="experienceOptions"
                  v-on:payment-authorized="paymentAuthorized" v-on:payment-completed="paymentCompleted" v-on:payment-cancelled="paymentCancelled">
                </paypal-checkout>

                <div v-if="autoReNew && !loadButtons" id="paypal-button-container"></div>

                </h2>


                <h2 class="center widthFull mb-3 mt-3 bgWhite">
                <!-- CLASSIC -->
                <stripePayment v-if="item.enea_request == '0' && item.to_get_cadastral_data == '0'"
                  :items="[{'name': 'CHEBONUS-' + item.code,'description': 'PRATICA_' + item.code, 'price': '' + buyPlan.amount, 'quantity': '1', 'currency': 'EUR'}]"
                  :invoiceNumber="'CHEBONUS_PRATICA_' + item.code"
                  :amount="'' + buyPlan.amount"
                  :practice="item.code"
                  :userToken="getProfile.userToken"
                />

                <!-- CLASSIC + ENEA -->
                <stripePayment v-if="item.enea_request != '0' && item.to_get_cadastral_data == '0'"
                  :items="[
                  {'name': 'CHEBONUS-' + item.code,'description': 'PRATICA_' + item.code, 'price': '' + buyPlan.amount, 'quantity': '1', 'currency': 'EUR'},
                  {'name': 'Pratica ENEA','description': 'Servizio di redazione e invio pratica ENEA', 'price': '' + buyPlan.priceEnea * 1.22, 'quantity': '1', 'currency': 'EUR'}]"
                  :amount="'' + buyPlan.amount_enea"
                  :invoiceNumber="'CHEBONUS_PRATICA_' + item.code"
                  :practice="item.code"
                  :userToken="getProfile.userToken"
                />

                <!-- CLASSIC + DCAST -->
                <stripePayment  v-if="item.enea_request == '0' && item.to_get_cadastral_data != '0'"
                  :amount="'' + buyPlan.amount_dcast"
                  :items="[
                  {'name': 'CHEBONUS-' + item.code,'description': 'PRATICA_' + item.code, 'price': '' + buyPlan.amount, 'quantity': '1', 'currency': 'EUR'},
                  {'name': 'Visura Catastale','description': 'Servizio Visura Catastale', 'price': '' + buyPlan.priceDcast * 1.22, 'quantity': '1', 'currency': 'EUR'}]"
                  :invoiceNumber="'CHEBONUS_PRATICA_' + item.code"
                  :practice="item.code"
                  :userToken="getProfile.userToken"
                />

                <!-- CLASSIC + ENEA + DCAST -->
                <stripePayment  v-if="item.enea_request != '0' && item.to_get_cadastral_data != '0'"
                  :amount="'' + buyPlan.amount_enea_dcast" :invoice-number="'CHEBONUS_PRATICA_' + item.code"
                  :items="[
                  {'name': 'CHEBONUS-' + item.code,'description': 'PRATICA_' + item.code, 'price': '' + buyPlan.amount, 'quantity': '1', 'currency': 'EUR'},
                  {'name': 'Pratica ENEA','description': 'Servizio di redazione e invio pratica ENEA', 'price': '' + buyPlan.priceEnea * 1.22, 'quantity': '1', 'currency': 'EUR'},
                  {'name': 'Visura Catastale','description': 'Servizio Visura Catastale', 'price': '' + buyPlan.priceDcast * 1.22, 'quantity': '1', 'currency': 'EUR'}]"
                  :invoiceNumber="'CHEBONUS_PRATICA_' + item.code"
                  :practice="item.code"
                  :userToken="getProfile.userToken"
                />

              </h2>
              <!--
              <p v-if="loadButtons" class="center mt-4">
                <img class="img-fluid smallLoading" src="../../assets/images/load2.gif">
              </p>
            -->
            </div>
          </div>
        </div>
        <div v-if="paySuccess" class="col-sm-12 center">
          <img class="img-fluid payImage" src="../../assets/images/success.png">
          <br />
          <h1 class="center">Grazie per averci scelto, </h1>
          <h3 class="center">il tuo pagamento è avvenuto con successo</h3>

          <button class="btn btn-primary rn-btn-dark mt-5" v-on:click="payment = true">
            <span class="hover hover-1">Procedi</span>
          </button>

        </div>
      </div>


    </div>

    </div>

    <!--  PAYMENT OK ******************************************************************************************************************** -->

    <div v-if="payment && loaded" class="container  mt-5 mb-5 pb-5 pt-4">

      <!--   HEADER TITLE    ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
      <div class="row justify-content-center text-left">
        <h3 class="Regular center h0 widthFull"><b>Pratica N. {{item.code}} </b></h3>


        <div class="col-md-8 center mb-3 text-left">

          <h4 class="Regular text-left h0 widthFull "><b> Gestione Documenti </b></h4>
          <p class="black mt-0 text-left widthFull ">
            Prepara e carica tutti i documenti richiesti. Al termine dell caricamento ogni singolo documento clicca su pulsante CONCLUDI.
          </p>

          <p class="black mt-0 text-left widthFull ">
            <font-awesome-icon class="mr-2" icon="star-of-life" size="" /> <b>Documenti Obbligatori</b>
          </p>
        </div>

        <div class="col-md-4 pt-md-4 center mb-3 text-right">
          <router-link :to="{ name: 'pratiche'}" class="btn btn-primary m-2 btn-sm ml-md-5">
            <font-awesome-icon icon="arrow-left" size="1x" />
            Indietro
          </router-link>
        </div>

      </div>

      <form class="pb-5 mb-5 black pt-2 pl-4 pr-4 widthFull vaillantCont" id="doc-form">
        <div v-for="(doc,index,k) in documents[item.client_type]" v-if=" ( doc.codice != '2050D11' || item.dcast_export == '10' && doc.codice == '2050D11' || item.to_get_cadastral_data == '0' && doc.codice == '2050D11' ) && hasPrev"  class="row justify-content-center vaillantCont pt-2 pb-2" :class="{'pt-0': k == 0, 'even': String(k / 2).includes('.') }">
          <div class="col-12 col-md-1 bordered center tablePdMob">
            <img v-if="!uploadFrontPercentage[index]['countImages'] || uploadFrontPercentage[index]['hasError'] == 'yes'" class="img-fluid widthFull maxBomTr" src="../../assets/images/traficLight_red.png">
            <img v-if="uploadFrontPercentage[index]['countImages'] && !uploadFrontPercentage[index]['completed'] && uploadFrontPercentage[index]['hasError'] == 'no'" class="img-fluid widthFull maxBomTr"
              src="../../assets/images/traficLight_yellow.png">
            <img v-if="uploadFrontPercentage[index]['completed'] && uploadFrontPercentage[index]['hasError'] == 'no'" class="img-fluid widthFull maxBomTr" src="../../assets/images/traficLight_green.png">
          </div>

          <div class="col-12 col-md-5 bordered text-center text-md-left">

            <h5 class="widthFull black mt-0 pt-0 docTitleMob pl-md-3">
              <font-awesome-icon v-if="doc.mandatory == 'yes'" class="mandatoryDoc" icon="star-of-life" size="xs" /> {{doc.name}}
              <span v-if="uploadFrontPercentage[index]['hasError'] == 'yes'" class="widthFull red mt-0 pt-0 docTitleMob pl-md-3">
                Rilevata la seguente anomalia: <br/>{{ uploadFrontPercentage[index]['error'] }}
              </span>
            </h5>


            <div v-if="errors.has('fileInput' + index)" class="invalid-feedback-custom">
              {{ errors.first('fileInput' + index) }}
            </div>

            <div v-if="uploadFrontPercentage[index]['percent']" class="progress" id="progFront">
              <div class="progress-bar" id="progress-bar-front" role="progressbar" v-bind:style="{width: uploadFrontPercentage[index]['percent'] + '%'}" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">
                {{ uploadFrontPercentage[index]['percent'] }} %
              </div>
            </div>

          </div>

          <div class="col-6 col-md-2 text-right bordered  tablePdMob" :class="{'d-none d-md-block': doc.template == 'no', 'd-block d-md-block': doc.template == 'yes'}">

            <a v-if="doc.template == 'yes' && !uploadFrontPercentage[index]['completed'] && ( doc.codice != '2050D0B' ) " :href="doc.template_link" target="_blank" class="btn btn-primary btn-xl mt-3 mt-md-0" type="button">Modulo</a>

            <!-- TO CHANGE DOC -->
            <a v-if="doc.template == 'yes' && !uploadFrontPercentage[index]['completed'] && ( ( getProfile.tipo_azienda != 'Ditta Individuale' && getProfile.tipo_azienda != 'Professionista iscritto ad albi' ) && doc.codice == '2050D0B' ) " :href="doc.template_link" target="_blank" class="btn btn-primary btn-xl mt-3 mt-md-0" type="button">Istruzioni</a>

            <a v-if="doc.template == 'yes' && !uploadFrontPercentage[index]['completed'] && ( ( getProfile.tipo_azienda == 'Ditta Individuale' || getProfile.tipo_azienda == 'Professionista iscritto ad albi' ) && doc.codice == '2050D0B' ) " href="https://storage.googleapis.com/stage_novatag/ecobonus/2050D0Bd.vt.pdf" target="_blank" class="btn btn-primary btn-xl mt-3 mt-md-0" type="button">Istruzioni</a>

          </div>


          <div :class="{'col-12 center': doc.template == 'no', 'col-6': doc.template == 'yes'}" class=" col-md-1 bordered tablePdMob">

            <div v-if="( !uploadFrontPercentage[index]['completed']  && item.status == 1 && uploadFrontPercentage[index]['hasError'] == 'no' ) " class="front-image2">

              <input type="file" v-on:change="uploadFile(index,item.code,doc.name,doc.codice)" :ref="'fileInput' + index" :name="'fileInput' + index" :id="'fileInput' + index" class="btn btn-primary btn-xl" :data-vv-as="doc.name"
                v-validate="{required: doc.mandatory == 'yes',size: 2*10240, ext: ['jpeg','jpg','png','pdf'], mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}"
                :class="{ 'is-invalid': errors.has('fileInput' + index), valid: !!invoiceFront, helper: !!invoiceFrontBucket }">
              <span class="highlight"></span>
              <span class="bar"></span>

              <label class="niceInputLabel2 labelFileInput" for="invoiceFront">
                <span class="smallText center white">
                </span>
              </label>

              <!--
            <p v-if="invoiceFrontName" class="smallText center white mt-3 mb-0 pb-0 fileNameText">{{invoiceFrontName}}</p>
          -->
            </div>

            <router-link v-else-if="( uploadFrontPercentage[index]['completed'] && item.status == 1 && item.hasErrors == 'no') || ( item.status == 1 && uploadFrontPercentage[index]['hasError'] == 'yes' )" class="btn btn-primary btn-xl" :to="{ name: 'editDocument', params: {doc: doc, dbdoc: uploadFrontPercentage[index], item: item, docIndex: index }}">
              Modifica
            </router-link>

          </div>


          <div class="col-4 col-md-1 bordered tablePdMob">

            <button v-if="uploadFrontPercentage[index]['countImages']" class="btn btn-primary btn-xl" v-on:click="show(index)" type="button">Visualizza</button>

            <!-- @inited="inited" -->
            <viewer class="imagesViewer clearfix widthFull" :ref="'viewer' + index">
              <template v-for="(image, key) in uploadFrontPercentage[index]['images']">
                <img v-if="image.substring(image.lastIndexOf('.')+1, image.length).toLowerCase() != 'pdf'" :src="image" :key="key" class="img-fluid">
                <a v-else :href="image" class="pdfViewer" :key="key"  target="_blank">
                  <img src="../../assets/images/pdf.png" class="img-fluid">
                </a>
              </template>
            </viewer>

          </div>
          <div class="col-4 col-md-1 text-center bordered tablePdMob">
            <template v-for="(img,num) in uploadFrontPercentage[index]['images']" >

              <a class="docThumb" :key="num" v-if="img.substring(img.lastIndexOf('.')+1, img.length).toLowerCase() != 'pdf'" target="_blank">
                <font-awesome-icon icon="file-alt" />
              </a>
              <a :key="num" class="docThumb relative" v-else :href="img" target="_blank">
                <font-awesome-icon icon="file-pdf" class="" /> <small class="littlePdf">PDF</small>
              </a>

            </template>

          </div>

          <div class="col-4 col-md-1 center bordered tablePdMob">

            <button v-if="uploadFrontPercentage[index]['countImages'] && !uploadFrontPercentage[index]['completed']" class="btn btn-primary btn-green btn-xl" v-on:click="closeDocumentBlock(index,item.code,doc.name,doc.codice)"
              type="button">Concludi</button>
            <font-awesome-icon v-else-if="uploadFrontPercentage[index]['completed']" icon="check" />

          </div>

        </div>
        <div v-for="(doc,index,k) in documents[item.client_type]" v-if="!hasPrev"  class="row justify-content-center vaillantCont pt-2 pb-2" :class="{'pt-0': k == 0, 'even': String(k / 2).includes('.') }">
          <div class="col-12 col-md-1 bordered center tablePdMob">
            <img v-if="!uploadFrontPercentage[index]['countImages'] || uploadFrontPercentage[index]['hasError'] == 'yes'" class="img-fluid widthFull maxBomTr" src="../../assets/images/traficLight_red.png">
            <img v-if="uploadFrontPercentage[index]['countImages'] && !uploadFrontPercentage[index]['completed'] && uploadFrontPercentage[index]['hasError'] == 'no'" class="img-fluid widthFull maxBomTr"
              src="../../assets/images/traficLight_yellow.png">
            <img v-if="uploadFrontPercentage[index]['completed'] && uploadFrontPercentage[index]['hasError'] == 'no'" class="img-fluid widthFull maxBomTr" src="../../assets/images/traficLight_green.png">
          </div>

          <div class="col-12 col-md-5 bordered text-center text-md-left">

            <h5 class="widthFull black mt-0 pt-0 docTitleMob pl-md-3">
              <font-awesome-icon v-if="doc.mandatory == 'yes'" class="mandatoryDoc" icon="star-of-life" size="xs" /> {{doc.name}}
              <span v-if="uploadFrontPercentage[index]['hasError'] == 'yes'" class="widthFull red mt-0 pt-0 docTitleMob pl-md-3">
                Rilevata la seguente anomalia: <br/>{{ uploadFrontPercentage[index]['error'] }}
              </span>
            </h5>


            <div v-if="errors.has('fileInput' + index)" class="invalid-feedback-custom">
              {{ errors.first('fileInput' + index) }}
            </div>

            <div v-if="uploadFrontPercentage[index]['percent']" class="progress" id="progFront">
              <div class="progress-bar" id="progress-bar-front" role="progressbar" v-bind:style="{width: uploadFrontPercentage[index]['percent'] + '%'}" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">
                {{ uploadFrontPercentage[index]['percent'] }} %
              </div>
            </div>

          </div>

          <div class="col-6 col-md-2 text-right bordered  tablePdMob" :class="{'d-none d-md-block': doc.template == 'no', 'd-block d-md-block': doc.template == 'yes'}">

            <a v-if="doc.template == 'yes' && !uploadFrontPercentage[index]['completed'] && ( doc.codice != '2050D0B' ) " :href="doc.template_link" target="_blank" class="btn btn-primary btn-xl mt-3 mt-md-0" type="button">Modulo</a>

            <!-- TO CHANGE DOC -->
            <a v-if="doc.template == 'yes' && !uploadFrontPercentage[index]['completed'] && ( ( getProfile.tipo_azienda != 'Ditta Individuale' && getProfile.tipo_azienda != 'Professionista iscritto ad albi' ) && doc.codice == '2050D0B' ) " :href="doc.template_link" target="_blank" class="btn btn-primary btn-xl mt-3 mt-md-0" type="button">Istruzioni</a>

            <a v-if="doc.template == 'yes' && !uploadFrontPercentage[index]['completed'] && ( ( getProfile.tipo_azienda == 'Ditta Individuale' || getProfile.tipo_azienda == 'Professionista iscritto ad albi' ) && doc.codice == '2050D0B' ) " href="https://storage.googleapis.com/stage_novatag/ecobonus/2050D0Bd.vt.pdf" target="_blank" class="btn btn-primary btn-xl mt-3 mt-md-0" type="button">Istruzioni</a>

          </div>


          <div :class="{'col-12 center': doc.template == 'no', 'col-6': doc.template == 'yes'}" class=" col-md-1 bordered tablePdMob">

            <div v-if="( !uploadFrontPercentage[index]['completed']  && item.status == 1 && uploadFrontPercentage[index]['hasError'] == 'no' ) " class="front-image2">

              <input type="file" v-on:change="uploadFile(index,item.code,doc.name,doc.codice)" :ref="'fileInput' + index" :name="'fileInput' + index" :id="'fileInput' + index" class="btn btn-primary btn-xl" :data-vv-as="doc.name"
                v-validate="{required: doc.mandatory == 'yes',size: 2*10240, ext: ['jpeg','jpg','png','pdf'], mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}"
                :class="{ 'is-invalid': errors.has('fileInput' + index), valid: !!invoiceFront, helper: !!invoiceFrontBucket }">
              <span class="highlight"></span>
              <span class="bar"></span>

              <label class="niceInputLabel2 labelFileInput" for="invoiceFront">
                <span class="smallText center white">
                </span>
              </label>

              <!--
            <p v-if="invoiceFrontName" class="smallText center white mt-3 mb-0 pb-0 fileNameText">{{invoiceFrontName}}</p>
          -->
            </div>

            <router-link v-else-if="( uploadFrontPercentage[index]['completed'] && item.status == 1 && item.hasErrors == 'no') || ( item.status == 1 && uploadFrontPercentage[index]['hasError'] == 'yes' )" class="btn btn-primary btn-xl" :to="{ name: 'editDocument', params: {doc: doc, dbdoc: uploadFrontPercentage[index], item: item, docIndex: index }}">
              Modifica
            </router-link>

          </div>


          <div class="col-4 col-md-1 bordered tablePdMob">

            <button v-if="uploadFrontPercentage[index]['countImages']" class="btn btn-primary btn-xl" v-on:click="show(index)" type="button">Visualizza</button>

            <!-- @inited="inited" -->
            <viewer class="imagesViewer clearfix widthFull" :ref="'viewer' + index">
             
              <template v-for="(image, key) in uploadFrontPercentage[index]['images']">
                <img v-if="image.substring(image.lastIndexOf('.')+1, image.length).toLowerCase() != 'pdf'" :src="image" :key="key" class="img-fluid">
                <a v-else :href="image" class="pdfViewer" :key="key" target="_blank">
                  <img src="../../assets/images/pdf.png"  class="img-fluid">
                </a>
              </template>
            </viewer>

          </div>
          <div class="col-4 col-md-1 text-center bordered tablePdMob">
            <template v-for="(img,num) in uploadFrontPercentage[index]['images']">
              
              <a :key="num" class="docThumb" v-if="img.substring(img.lastIndexOf('.')+1, img.length).toLowerCase() != 'pdf'" target="_blank">
                <font-awesome-icon icon="file-alt" />
              </a>
              <a :key="num" class="docThumb relative" v-else  target="_blank">
                <font-awesome-icon icon="file-pdf" class="" /> <small class="littlePdf">PDF</small>
              </a>

            </template>

          </div>

          <div class="col-4 col-md-1 center bordered tablePdMob">

            <button v-if="uploadFrontPercentage[index]['countImages'] && !uploadFrontPercentage[index]['completed']" class="btn btn-primary btn-green btn-xl" v-on:click="closeDocumentBlock(index,item.code,doc.name,doc.codice)"
              type="button">Concludi</button>
            <font-awesome-icon v-else-if="uploadFrontPercentage[index]['completed']" icon="check" />

          </div>

        </div>

        <!-- ENEA DOCUMENTS REQUEST ************************************************************************* -->
        <div v-if=" item.aditional_enea_data == null && item.enea_request == '1' && 2==3" class="col-md-12 center mb-4">
          <h5 class="Regular text-center h0 widthFull ">
            <b v-if="concluded"><span class="yellow">Attenzione!</span> Per redigere e inviare la Pratica ENEA abbiamo necessità di ulteriori informazioni </b>
            <b v-else><span class="yellow">Attenzione!</span>  Per redigere ed inviare la pratica ENEA avremo bisogno di ulteriori informazioni che ti chiederemo alla conclusione del Set Documentale. </b>

            <router-link v-if="concluded" :to="{ name: 'complateEneaData', params: {item: item} }" class="btn btn-primary m-2 btn-sm">
              Inserisci
            </router-link>
          </h5>

        </div>
        <!-- END DOCUMENTS REQUEST ************************************************************************* -->


        <div v-if="item.status == 1" class="row justify-content-center">
          <div class="col-12 col-md-12 text-right">
            <button class="btn btn-primary" type="button" v-on:click="sendPracticeToKPMG()">Procedi</button>
          </div>
        </div>

      </form>



    </div>



</div>
</template>

<script>
import { AUTH_REQUEST, AUTH_SOCIAL } from "actions/auth";
import { mapGetters, mapState } from "vuex";
import axios from "axios";
import "viewerjs/dist/viewer.css";

import Vue from "vue";

import stripePayment from "./stripe.vue";

const moment = require("moment");

const viewer = require("v-viewer");

//import { StripeCheckout } from '@vue-stripe/vue-stripe'

// GET DOC LIST
import documents from "../../components/documents/documents.js";
import documentsHoval from "../../components/documents/documentsHoval.js";
import documentsEmicon from "../../components/documents/documentsEmicon.js";

import imageToBase64 from "image-to-base64/browser";

export default {
  name: "loadDocuments",
  components: {
    //StripeCheckout
    stripePayment,
  },
  data() {
    return {
      token: "",
      loadingState: false,
      loading: false,
      practices: {},
      moment: require("moment"),
      item: false,
      componentKey: 0,
      email: "",
      codice_fiscale: "",
      partita_iva: "",
      phone: "",
      cellulare: "",
      address: "",
      civic: "",
      hasPrev: false,
      region: "",
      province: "",
      city: "",
      zip: "",
      regions: [],
      regionsState: true,
      provincies: [],
      provinciesState: false,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      provinceError: false,
      cityError: false,
      zipError: false,
      invoiceFront: "",
      invoiceFrontName: "",
      invoiceFrontBucket: "",
      uploadFrontPercentage: {},
      client_ownership: "",
      subalterno: "",
      particella: "",
      savedDocuments: {},
      foglio: "",
      documents: documents,
      documentsHoval: documentsHoval,
      documentsEmicon: documentsEmicon,
      payment: false,

      paymentTypeD: "",
      paid: "",
      autoRenewD: "",
      priceIvaC: "",
      priceIvaA: "",
      priceIfYearSubIva: "",
      priceIva: "",

      //STRIPE
      pk: process.env.STRIPE_PUBLISHABLE_KEY,
      front_url: process.env.FRONT_END_URL,
      iva: process.env.IVA,
      buyPlan: {
        price: process.env.PRACTIC_PRICE,
        iva: process.env.PRACTIC_PRICE * 0.22,
        amount: process.env.PRACTIC_PRICE + process.env.PRACTIC_PRICE * 0.22,
        amount_enea: parseFloat(
          process.env.PRACTIC_PRICE +
            process.env.PRACTIC_PRICE * 0.22 +
            50 * 1.22
        ).toFixed(2),
        amount_dcast: parseFloat(
          process.env.PRACTIC_PRICE +
            process.env.PRACTIC_PRICE * 0.22 +
            10 * 1.22
        ).toFixed(2),
        amount_enea_dcast: parseFloat(
          process.env.PRACTIC_PRICE +
            process.env.PRACTIC_PRICE * 0.22 +
            50 * 1.22 +
            10 * 1.22
        ).toFixed(2),
        priceEnea: 50,
        ivaEnea: 11,
        priceDcast: 10,
        ivaDcast: 2.2,
      },
      billingType: false,
      autoReNew: false,
      envPP: "",
      credentials: {
        sandbox: process.env.PAYPAL_ID,
        production: process.env.PAYPAL_ID,
        // SECRET ENSsI2hX79egH1CKfDNPQnf0SskbcGt0r9GRiVDwNMArGz2HAMP6c3-960hpQka2gXob5GzcDbAUNlfY
      },
      experienceOptions: {
        input_fields: {
          no_shipping: 1,
        },
      },
      paySuccess: false,
      PPAUTHTOKEN: false,
      loadButtons: false,
      loaded: false,
      concluded: false,
    };
  },
  methods: {
    submit() {
      // You will be redirected to Stripe's secure checkout page
      this.$refs.checkoutRef.redirectToCheckout();
    },
    base64(file) {
      // read binary data
      const assert = require("assert");
      const pt = require("path");

      let url = "https://www.mattiafossati.com/img/header-img.png";
      let path = pt.resolve("test/nodejs.png");
      let validBase64 = new RegExp(
        "^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{0,2}==)$",
        "gim"
      );

      imageToBase64(url)
        .then((data) => {
          assert(validBase64.test(data), true);
        })
        .catch((err) => assert(err, true));

      imageToBase64(path)
        .then((data) => {
          assert(validBase64.test(data).test(data), true);
        })
        .catch((err) => assert(err, true));
    },
    setProfile: function () {
      //type 1 => no preventivatore
      if (this.getProfile.type == 1) {
        this.hasPrev = false;
      } else {
        this.hasPrev = true;
      }
      if (this.getProfile.status == "admin") {
        this.adminIs = true;
        this.AdminId = this.getProfile.id;
        this.flagForCheck = this.getProfile.type;
      } else if (this.getProfile.status == "user") {
        this.adminIs = false;
        this.flagForCheck = this.getProfile.type;
      }
    },
    sendPracticeToKPMG: async function () {
      this.$validator.validate().then(async (valid) => {
        var _vue = this;
        this.concluded = true;
        for (var p in _vue.uploadFrontPercentage) {
          if (
            !_vue.uploadFrontPercentage[p]["completed"] &&
            _vue.uploadFrontPercentage[p]["mandatory"] == "yes"
          ) {
            this.concluded = false;
          }
        }

        if (this.concluded) {
          this.loadingState = true;
          if (this.adminIs) {
            this.$warn(this.item);
            if (this.item.admin_ref) {
              this.$log("------------------");
              var dataUser = { token: this.item.userToken_user };
              this.$log(dataUser);
              dataUser = this.$encryptByAES(
                JSON.stringify(dataUser),
                process.env.CRYPTKEY
              );
              await axios({
                url: process.env.ROOT_API + "api/getUserForKPMG",
                method: "POST",
                data: { dataUser },
                headers: {
                  Authorization: "Bearer " + process.env.AUTH_TOKEN,
                  "Content-type": "application/json",
                },
              })
                .then((resp) => {
                  resp.data = this.$decryptByAES(
                    resp.data,
                    process.env.CRYPTKEY
                  );
                  this.$warn(resp.data);
                  this.passUSer = resp.data;
                })
                .catch((resp) => {
                  this.loadingState = false;
                  this.showAlert();
                });
            }
          } else {
            this.passUSer = this.getProfile;
          }

          var data = {
            docs: this.uploadFrontPercentage,
            practice: this.item,
            user: this.passUSer,
          };

          if (valid) {
          } else {
          }
          data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);

          axios({
            url: process.env.ROOT_API + "api/sendPracticeToKPMG",
            method: "POST",
            data: { data },
            headers: {
              Authorization: "Bearer " + process.env.AUTH_TOKEN,
              "Content-type": "application/json",
            },
          })
            .then((resp) => {
              this.loadingState = false;
              _vue.$router.push("/pratiche");
            })
            .catch((resp) => {
              this.loadingState = false;
              this.showAlert();
            });
        } else {
          this.showAlertNotConcluded();
        }
      });
    },
    paymentAuthorized: function (data) {
      //this.$log(data);
    },
    paymentCompleted: async function (data) {
      var trans = data;
      var _vue = this;
      if (trans.state == "approved") {
        //this.$warn(trans)
        await _vue.saveSubscription(trans);
        _vue.paySuccess = true;
      }
    },
    paymentCancelled: function (data) {
      this.$swal({
        type: "error",
        title: '<strong class="modalText danger">Ci dispiace, </strong>',
        html: "<p>il pagamento non è andato a buon fine</p>",
        confirmButtonText: "CHIUDI",
        confirmButtonColor: "#15267",
      });
    },
    getAuthToken: async function () {
      this.$log("1) CREATE TOKEN");
      var _vue = this;
      var urlencoded = new URLSearchParams();
      urlencoded.append("grant_type", "client_credentials");

      var envNow = "";
      if (process.env.PAYPAL_ENV == "SANDBOX") {
        envNow = ".sandbox";
      }

      await axios({
        url: "https://api" + envNow + ".paypal.com/v1/oauth2/token",
        method: "POST",
        data: urlencoded,
        auth: {
          username: process.env.PAYPAL_ID,
          password: process.env.PAYPAL_SECRET,
        },
        headers: {
          //'Authorization': 'Basic Basic QWVTNlpENmliWmNnVzJXUHFoX1ppVnBSQ09iWFlOdzJMUFAtTE1yTTIxNUFEYVhsWkRCeW5US0FPXy1uTDRJa3dycS1FQUY4TG9MZWRMNU06RU5Tc0kyaFg3OWVnSDFDS2ZETlBRbmYwU3NrYmNHdDByOUdSaVZEd05NQXJHejJIQU1QNmMzLTk2MGhwUWthMmdYb2I1R3pjRGJBVU5sZlk=',
          "Content-type": "application/x-www-form-urlencoded",
        },
      })
        .then((resp) => {
          //this.$log(resp.data)
          _vue.PPAUTHTOKEN = resp.data.access_token;
          this.$log("1) SUCCESS");
          //this.$warn(urlencoded)

          //_vue.test()

          _vue.createBillingPlan();
        })
        .catch((resp) => {
          this.$log(resp.response);
        });
    },
    saveSubscription: async function (trans) {
      var _vue = this;
      const recaptcha = this.$recaptchaInstance;
      // (optional) Wait until recaptcha has been loaded.
      await _vue.$recaptchaLoaded();
      // Execute reCAPTCHA with action "login".
      var token = await _vue.$recaptcha("login");

      this.paymentTypeD = "Practice";
      _vue.buyPlan.paymentType = "practice";
      _vue.buyPlan.expiredAt = moment()
        .add(1, "months")
        .format("YYYY-MM-DD HH:mm:ss");

      this.autoRenewD = "Disattivato";
      _vue.buyPlan.autoRenew = "no";

      //this.$warn(trans)
      axios({
        url: process.env.ROOT_API + "api/addPayment",
        method: "POST",
        data: {
          token: token,
          userToken: _vue.getProfile.userToken,
          user: _vue.getProfile,
          subscription: _vue.buyPlan,
          transaction: trans,
          practice: this.item,
        },
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          this.$log(resp.data);
        })
        .catch((resp) => {
          //this.$log(resp.response)
        }),
        await _vue.$recaptchaLoaded();
      token = await _vue.$recaptcha("login");
    },
    inited(viewer) {
      var _vue = this;
      this.$viewer = viewer;
      this.$log(viewer);

      this.$log("ZOOOOOM");

      setTimeout(function () {
        _vue.$viewer.zoom(1);
      }, 1000);
    },
    show(index) {
      this.$log(this);
      var el = this.$refs["viewer" + index];

      this.$log(this.$refs);

      this.$log(el[0]);

      //const viewerV = el.$viewer

      el[0].destroyViewer();

      el[0].createViewer();

      el[0].$viewer.show();
      //viewer.zoomTo(2)
      //	viewer.move(-1, 0);
    },

    populateProvincies: function () {
      const { provincies, provinciesState } = this;

      axios({
        url: process.env.ROOT_API + "api/getProvinciesAll",
        method: "POST",
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          var data = { code: "93423599123471013491" };
          data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
          axios({
            url:
              process.env.ROOT_API +
              "api/3re54fde556423DDWWE2345Esdsfwe443245trtfwEFW",
            method: "POST",
            data: {
              data,
            },
            headers: {
              Authorization: "Bearer " + process.env.AUTH_TOKEN,
              "Content-type": "application/json",
            },
          });
          this.provincies = resp.data.provincies;
          this.provinciesState = false;
        })
        .catch((resp) => {
          this.provincies = [];
          this.provinciesState = false;
        });
    },
    checkProvince: function () {
      const { province } = this;
      if (province) {
        this.cityError = false;
      } else {
        this.cityError = true;
      }
    },
    checkZip: function () {
      const { city } = this;
      if (city) {
        this.zipError = false;
      } else {
        this.zipError = true;
      }
    },
    showAlert() {
      // Use sweetalret2
      this.$swal({
        type: "error",
        title: "Oops...",
        text: "Ci dispiace! Riprova piu tardi",
      });
    },
    showAlertNotConcluded() {
      // Use sweetalret2
      this.$swal({
        type: "warning",
        title: "Attenzione!",
        text: "Prima di procedere concludi il caricamento di tutti i documenti",
      });
    },
    async setCap(cap) {
      for (var x in this.zips) {
        if (this.zips[x].cap == cap.toUpperCase()) {
          this.zip = this.zips[x].cap;
        }
      }
    },
    async setCity(city) {
      for (var x in this.cities) {
        if (this.cities[x].comune == city.toUpperCase()) {
          var k = {
            cityistat: this.cities[x].istat,
            city: city.toUpperCase(),
          };
          this.city = k;
        }
      }
      this.$log(this.city);
    },
    async setProvince(province) {
      for (var x in this.provincies) {
        this.$log("START");
        this.$log(this.provincies[x].sigla + " =?= " + province.toUpperCase());
        if (this.provincies[x].sigla == province.toUpperCase()) {
          this.province = this.provincies[x].sigla;
        }
      }
      this.$log(this.province);
    },
    closeDocumentBlock(doc, code, name, docCode) {
      var _vue = this;
      var data = {};
      data.doc = doc;
      data.code = code;
      data.name = name;
      data.docCode = docCode;

      axios({
        url: process.env.ROOT_API + "api/closeDocumentBlock",
        method: "POST",
        data: {
          data: data,
        },
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          var r = this.uploadFrontPercentage[data.doc];
          r["completed"] = 1;
          //r['hasError'] = 'no'
          Vue.set(this.uploadFrontPercentage, data.doc, r);

          // NEW
          _vue.concluded = true;
          for (var p in _vue.uploadFrontPercentage) {
            if (
              !_vue.uploadFrontPercentage[p]["completed"] &&
              _vue.uploadFrontPercentage[p]["mandatory"] == "yes"
            ) {
              _vue.concluded = false;
            }
          }
        })
        .catch((resp) => {});
    },
    uploadFile(doc, code, name, docCode) {
      this.loadingState = true;
      var data = { code: "93423599123471013491" };
      data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
      axios({
        url:
          process.env.ROOT_API +
          "api/3re54fde556423DDWWE2345Esdsfwe443245trtfwEFW",
        method: "POST",
        data: {
          data,
        },
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      });
      this.$log(this.$refs["fileInput" + doc]);
      var input = this.$refs["fileInput" + doc][0];

      //this.$log(input)

      console.log(doc)
      console.log(code)
      console.log(name)
      console.log(docCode)

      var ind = doc;
      //this.$log(0)
      var file = input.files[0].name;
      this.invoiceFrontName = file;
      var extension = file.substr(file.lastIndexOf(".") + 1).toLowerCase();
      var size = input.files[0].size;
      console.warn(size)
      if (
        (extension == "png" ||
          extension == "jpg" ||
          extension == "jpeg" ||
          extension == "pdf") &&
        size < 2*10506316
      ) {
        this.invoiceFront = input.files[0].name;
        var formData = new FormData();
        var _vue = this; // << here
        formData.append("fattura0", input.files[0]);

        //this.$log(this.uploadFrontPercentage)

        formData.append("doc", doc);
        formData.append("code", code);
        formData.append("name", name);
        formData.append("docCode", docCode);

        axios
          .post(process.env.ROOT_API + "api/uploadDocument", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + process.env.AUTH_TOKEN,
            },
            onUploadProgress: function (progressEvent) {
              var r = this.uploadFrontPercentage[ind];

              r["percent"] = parseInt(
                Math.round((progressEvent.loaded * 100) / progressEvent.total)
              );

              //  Object.assign(this.uploadFrontPercentage, r)

              Vue.set(this.uploadFrontPercentage, ind, r);

              //  this.uploadFrontPercentage[ind]['percent'] = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
            }.bind(this),
          })
          .then(function (e) {
            _vue.loadingState = false;
            var regex =
              /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
            if (regex.test(e.data.document)) {
              _vue.uploadFrontPercentage[ind]["percent"] = 0;
              var x = _vue.uploadFrontPercentage[ind]["images"];

              x[e.data.id] = e.data.document;
              _vue.getDocuments(_vue.$route.params.item.code, "asdg2352rsdfgv");
              _vue.uploadFrontPercentage[ind]["images"] = x;
              _vue.uploadFrontPercentage[ind]["hasError"] = "no";
              _vue.uploadFrontPercentage[ind]["countImages"] = 1;
              _vue.uploadFrontPercentage[ind]["date"] = moment().format(
                "YYYY-MM-DD HH:mm:00"
              );
              console.log("ended");
              _vue.forcereloadDocs();
              //_vue.invoiceFrontBucket = e.data.fattura
            } else {
              _vue.uploadFrontPercentage[ind]["percent"] = 0;
              //console.log(_vue.$route.params.item.code);
              _vue.forcereloadDocs();
              //_vue.getDocuments(_vue.$route.params.item.code, "asdg2352rsdfgv");
              //console.log("ended - img");
              //_vue.componentKey += 1
              //console.log(_vue.componentKey)
              //_vue.$forceUpdate();
              /******************************** */

              /******************************** */
            }
          })
          .catch(function () {
            _vue.loadingState = false;
            _vue.uploadFrontPercentage.doc = 0;
            _vue.$log("|||||||");
            _vue.$error(_vue.uploadFrontPercentage);
            //  _vue.invoiceFront = ''
            ///  _vue.invoiceFrontBucket = ''

            //input.value = null
          });
      }
    },
    async forcereloadDocs() {
      var _vue = this;
      if (_vue.getProfile.corporateClient == "agnellimetalli") {
        _vue.documents = documents;
      }
      if (_vue.getProfile.corporateClient == "hoval") {
        _vue.documents = documentsHoval;
      }
      if (_vue.getProfile.corporateClient == "emicon") {
        _vue.documents = documentsEmicon;
      }

      if (process.env.PAYPAL_ENV == "SANDBOX") {
        _vue.envPP = "sandbox";
      }
      // DOC LIST PARSER
      var docTemp = _vue.documents[_vue.$route.params.item.client_type];
      _vue.documents[_vue.$route.params.item.client_type] = {};

      var selettore_titoloPossesso = _vue.$route.params.item.client_ownership;
      var selettore_enea = _vue.$route.params.item.enea_request;

      if (selettore_enea == "0") {
        selettore_enea = "no";
      } else {
        selettore_enea = "yes";
      }

      for (var ele in docTemp) {
        if (docTemp[ele].hasOwnProperty("codice")) {
          _vue.documents[_vue.$route.params.item.client_type][ele] =
            docTemp[ele];
        } else if (docTemp[ele].hasOwnProperty("selector")) {
          if (
            docTemp[ele]["selector"].hasOwnProperty(
              selettore_titoloPossesso.toLowerCase()
            )
          ) {
            var tmpList =
              docTemp[ele]["selector"][selettore_titoloPossesso.toLowerCase()];
          } else if (docTemp[ele]["selector"].hasOwnProperty(selettore_enea)) {
            var tmpList =
              docTemp[ele]["selector"][selettore_enea.toLowerCase()];
          }
          for (var eleS in tmpList) {
            _vue.documents[_vue.$route.params.item.client_type][eleS] =
              tmpList[eleS];
          }
        }
      }

      // ******************************************************************************************

      _vue.loadingState = true;
      //_vue.uploadFrontPercentage = {}

      Object.assign(_vue.uploadFrontPercentage, {});

      await _vue.getDocuments(_vue.$route.params.item.code, "asdg2352rsdfgv");

      for (var x in _vue.documents[_vue.$route.params.item.client_type]) {
        var z = {};
        z.images = {};
        z.countImages = 0;
        z.completed = 0;

        z.docname =
          _vue.documents[_vue.$route.params.item.client_type][x]["name"];

        if (
          (_vue.getProfile.tipo_azienda == "Ditta Individuale" ||
            _vue.getProfile.tipo_azienda ==
              "Professionista iscritto ad albi") &&
          _vue.documents[_vue.$route.params.item.client_type][x]["codice"] ==
            "2050D0B"
        ) {
          z.mandatory = "no";
          _vue.documents[_vue.$route.params.item.client_type][x]["mandatory"] =
            _vue.hasPrev ? "no" : "yes";
        } else {
          z.mandatory =
            _vue.documents[_vue.$route.params.item.client_type][x]["mandatory"];
        }

        // NEWW REMOVE MANDATORY ID REQUEST DATA CATASTALE
        if (
          _vue.documents[_vue.$route.params.item.client_type][x]["codice"] ==
            "2050D11" &&
          _vue.$route.params.item.to_get_cadastral_data == "1"
        ) {
          z.mandatory = _vue.hasPrev ? "no" : "yes";
          _vue.documents[_vue.$route.params.item.client_type][x]["mandatory"] =
            _vue.hasPrev ? "no" : "yes";
        } else {
          if (
            _vue.documents[_vue.$route.params.item.client_type][x]["codice"] ==
              "2050D11" &&
            _vue.$route.params.item.to_get_cadastral_data == "0"
          ) {
            z.mandatory = "yes";
            _vue.documents[_vue.$route.params.item.client_type][x][
              "mandatory"
            ] = "yes";
            _vue.$log("DOC 2050D11");
            _vue.$log(
              _vue.documents[_vue.$route.params.item.client_type][x][
                "mandatory"
              ]
            );
          } else {
            z.mandatory =
              _vue.documents[_vue.$route.params.item.client_type][x][
                "mandatory"
              ];
          }
        }

        z.hasError = "no";
        for (var y in _vue.savedDocuments) {
          if (_vue.savedDocuments[y].codice == x) {
            z.images[_vue.savedDocuments[y].id] = _vue.savedDocuments[y].url;
            z.countImages = 1;
            z.date = _vue.savedDocuments[y].date;
            z.completed = parseInt(_vue.savedDocuments[y].completed);
            z.hasError = _vue.savedDocuments[y].hasError;
            z.error = _vue.savedDocuments[y].error;
          }
        }
        z.percent = 0;
        var y = {};
        y[x] = z;
        Vue.set(_vue.uploadFrontPercentage, x, z);
      }
    },
    async getDocuments(code, user_token) {
      var data = { code: code, user_token: user_token };
      data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
      await axios({
        //OLD getDocumentsByCode

        url:
          process.env.ROOT_API +
          "api/3re54fde556423DDWWE2345Esdsfwe443245trtfwEFW",
        method: "POST",
        data: {
          data,
        },
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          resp.data = this.$decryptByAES(resp.data, process.env.CRYPTKEY);
          this.savedDocuments = resp.data.documents;
          this.loadingState = false;
        })
        .catch((resp) => {
          this.savedDocuments = {};
        });
    },

    checkIfIban() {
      /*if (this.getProfile) {
        if (this.getProfile.iban == "") {
          this.$swal({
            type: "warning",
            title: "Attenzione!",
            text: "Ricordati, che dovrai inserire l`Iban delle Poste Italiane prima della cessione del credito.",
          });

          //this.$router.push('/account')
        }
      }*/
    },
  },
  watch: {
    adress: function (val) {
      if (val) {
        this.adress = this.adress.toUpperCase();
      }
    },
    civic: function (val) {
      if (val) {
        this.civic = this.civic.toUpperCase();
      }
    },
    phone: function (val) {
      if (val) {
        this.phone = val.replace(/\D+/g, "");
      }
    },
    getProfile: function () {
      this.checkIfIban();
      this.setProfile();
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    province: function (newProvince) {
      this.zips = [];
      this.cities = [];
      this.zip = "";
      this.city = "";
      this.cityError = false;
      this.zipError = false;

      if (newProvince) {
        this.citiesState = true;
        axios({
          url: process.env.ROOT_API + "api/getComuni",
          method: "POST",
          data: {
            provincia: newProvince,
          },
          headers: {
            Authorization: "Bearer " + process.env.AUTH_TOKEN,
            "Content-type": "application/json",
          },
        })
          .then((resp) => {
            this.cities = resp.data.cities;
            this.citiesState = false;
          })
          .catch((resp) => {
            this.cities = [];
            this.citiesState = false;
          });
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    city: function (newCity) {
      this.zipError = false;
      this.zips = [];
      this.zip = "";

      if (newCity.cityistat) {
        this.zipsState = true;
        axios({
          url: process.env.ROOT_API + "api/getCap",
          method: "POST",
          data: {
            istat: newCity.cityistat,
          },
          headers: {
            Authorization: "Bearer " + process.env.AUTH_TOKEN,
            "Content-type": "application/json",
          },
        })
          .then((resp) => {
            this.zips = resp.data.zips;
            this.zipsState = false;
          })
          .catch((resp) => {
            this.zips = [];
            this.zipsState = false;
          });
      }
    },
  },
  async created() {
    this.setProfile();
    this.$warn(this.getProfile);
    if (this.getProfile.corporateClient == "agnellimetalli") {
      this.documents = documents;
    }
    if (this.getProfile.corporateClient == "hoval") {
      this.documents = documentsHoval;
    }
    if (this.getProfile.corporateClient == "emicon") {
      this.documents = documentsEmicon;
    }

    if (process.env.PAYPAL_ENV == "SANDBOX") {
      this.envPP = "sandbox";
    }
    // DOC LIST PARSER
    var docTemp = this.documents[this.$route.params.item.client_type];
    this.documents[this.$route.params.item.client_type] = {};

    var selettore_titoloPossesso = this.$route.params.item.client_ownership;
    var selettore_enea = this.$route.params.item.enea_request;

    if (selettore_enea == "0") {
      selettore_enea = "no";
    } else {
      selettore_enea = "yes";
    }

    for (var ele in docTemp) {
      if (docTemp[ele].hasOwnProperty("codice")) {
        this.documents[this.$route.params.item.client_type][ele] = docTemp[ele];
      } else if (docTemp[ele].hasOwnProperty("selector")) {
        if (
          docTemp[ele]["selector"].hasOwnProperty(
            selettore_titoloPossesso.toLowerCase()
          )
        ) {
          var tmpList =
            docTemp[ele]["selector"][selettore_titoloPossesso.toLowerCase()];
        } else if (docTemp[ele]["selector"].hasOwnProperty(selettore_enea)) {
          var tmpList = docTemp[ele]["selector"][selettore_enea.toLowerCase()];
        }
        for (var eleS in tmpList) {
          this.documents[this.$route.params.item.client_type][eleS] =
            tmpList[eleS];
        }
      }
    }

    // ******************************************************************************************

    this.loadingState = true;
    //this.uploadFrontPercentage = {}

    Object.assign(this.uploadFrontPercentage, {});

    await this.getDocuments(this.$route.params.item.code, "asdg2352rsdfgv");

    for (var x in this.documents[this.$route.params.item.client_type]) {
      var z = {};
      z.images = {};
      z.countImages = 0;
      z.completed = 0;

      z.docname =
        this.documents[this.$route.params.item.client_type][x]["name"];

      if (
        (this.getProfile.tipo_azienda == "Ditta Individuale" ||
          this.getProfile.tipo_azienda == "Professionista iscritto ad albi") &&
        this.documents[this.$route.params.item.client_type][x]["codice"] ==
          "2050D0B"
      ) {
        z.mandatory = "no";
        this.documents[this.$route.params.item.client_type][x]["mandatory"] =
          this.hasPrev ? "no" : "yes";
      } else {
        z.mandatory =
          this.documents[this.$route.params.item.client_type][x]["mandatory"];
      }

      // NEWW REMOVE MANDATORY ID REQUEST DATA CATASTALE
      if (
        this.documents[this.$route.params.item.client_type][x]["codice"] ==
          "2050D11" &&
        this.$route.params.item.to_get_cadastral_data == "1"
      ) {
        z.mandatory = this.hasPrev ? "no" : "yes";
        this.documents[this.$route.params.item.client_type][x]["mandatory"] =
          this.hasPrev ? "no" : "yes";
      } else {
        if (
          this.documents[this.$route.params.item.client_type][x]["codice"] ==
            "2050D11" &&
          this.$route.params.item.to_get_cadastral_data == "0"
        ) {
          z.mandatory = "yes";
          this.documents[this.$route.params.item.client_type][x]["mandatory"] =
            "yes";
          this.$log("DOC 2050D11");
          this.$log(
            this.documents[this.$route.params.item.client_type][x]["mandatory"]
          );
        } else {
          z.mandatory =
            this.documents[this.$route.params.item.client_type][x]["mandatory"];
        }
      }

      z.hasError = "no";
      for (var y in this.savedDocuments) {
        if (this.savedDocuments[y].codice == x) {
          z.images[this.savedDocuments[y].id] = this.savedDocuments[y].url;
          z.countImages = 1;
          z.date = this.savedDocuments[y].date;
          z.completed = parseInt(this.savedDocuments[y].completed);
          z.hasError = this.savedDocuments[y].hasError;
          z.error = this.savedDocuments[y].error;
        }
      }
      z.percent = 0;
      var y = {};
      y[x] = z;
      Vue.set(this.uploadFrontPercentage, x, z);
    }

    //this.$log(this.uploadFrontPercentage)

    this.loadingState = false;
  },
  mounted() {
    this.loadButtons = true;
    this.setProfile();
    if (this.$route.params.item) {
      this.item = this.$route.params.item;

      this.$log(this.item);

      if (
        this.item &&
        this.item.client_type != "Amministratore di condominio"
      ) {
        this.address = this.item.building_address;
        this.civic = this.item.building_civic;
      }

      if (this.item.payment_id == 0) {
        this.payment = false;

        if (process.env.PAYPAL_ENV == "SANDBOX") {
          this.envPP = "sandbox";
        }

        var _vue = this;

        this.$loadScript(
          "https://www.paypal.com/sdk/js?client-id=" +
            process.env.PAYPAL_ID +
            "&vault=true&currency=EUR"
        )
          .then(() => {
            this.loadButtons = false;
          })
          .catch(() => {
            // Failed to fetch script
          });
      } else {
        this.payment = true;
      }

      this.loaded = true;

      // NEW
      var _vue = this;
      setTimeout(function () {
        _vue.concluded = true;
        for (var p in _vue.uploadFrontPercentage) {
          if (
            !_vue.uploadFrontPercentage[p]["completed"] &&
            _vue.uploadFrontPercentage[p]["mandatory"] == "yes"
          ) {
            _vue.concluded = false;
          }
        }
      }, 1000);
    } else {
      this.$router.push("/pratiche");
    }

    this.checkIfIban();

    this.populateProvincies();
    this.$scrollTo("#app", 700, {
      offset: -75,
    });
  },
  computed: {
    ...mapGetters([
      "getProfile",
      "loginerror",
      "isAuthenticated",
      "isProfileLoaded",
      "authStatus",
    ]),
    ...mapState({
      profile: (state) => state.user.profile,
      //response: state => `${state.status.response.data}`,
    }),
  },
};
</script>

<style lang="scss" scoped>
$phone: 667px;
$tablet: 1024px;
$desktop: 1324px;
$lgscreen: 1524px;

.fileNameText {
  position: absolute;
  bottom: -37px;
  font-size: 17px;
  width: 100%;
  text-align: center;
  color: #0e3d8b !important;
  z-index: 12313;
  white-space: nowrap;
  word-wrap: break-word;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.borderTop {
  border-top: 3px solid #003d13;
  padding-top: 15px;
}

.shopIcon {
  width: 75px;
}

.bigTitle {
  font-size: 47px;
  color: #003d13;

  @media screen and (max-width: $phone) {
    font-size: 27px;
  }
}

.hideFileUpload {
  position: absolute;
  width: 100%;
  height: 110%;
  background: #000000;
  opacity: 0.4;
  top: -18px;
  left: 0;
  filter: blur(24px);
  z-index: 10000;
}

h5 {
  @media screen and (max-width: $phone) {
    font-size: 14px;
  }
}
.corporateImg {
  max-height: 153px;
}
.backImageInvoice {
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  text-align: center;
  > img {
    max-height: 477px;
    margin: 0 auto;
    cursor: pointer;
  }
}

.zoomImage {
  position: absolute;
  left: 48%;
  top: 230px;
  cursor: pointer;
}

.vcenter {
  align-items: center;
  align-self: center;
  vertical-align: middle;
  display: inherit;
}

.front-image2 {
  position: relative;
  margin: 0 auto;
  display: block;
  height: 29px;
  text-align: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-item-align: center;
  align-self: center;
  width: 100%;
  margin-bottom: 0;
  background: #00897e !important;
  color: white;
  border-radius: 5px;
  overflow: hidden;
  cursor: pointer;

  @media screen and (max-width: $tablet) {
    margin-top: 15px !important;
  }

  > .fileInputLabel {
    display: none;
  }

  > .invalid-feedback {
    display: block;
    position: absolute;
    bottom: 15px;
    font-weight: 800;
  }

  > input {
    position: absolute;
    filter: alpha(opacity=0);
    opacity: 0;
    left: 5px;
    width: 100%;
    height: 30px;
    z-index: 10;
    top: 0;

    cursor: pointer !important;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 99;
    /*This makes the button huge. If you want a bigger button, increase the font size*/
    font-size: 50px;
    /*Opacity settings for all browsers*/
    opacity: 0;
    -moz-opacity: 0;
    filter: progid:DXImageTransform.Microsoft.Alpha(opacity=0);
  }

  > label {
    /*display: none;*/
    cursor: pointer;
    width: 100%;
    margin: 0 auto;
    text-align: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-item-align: center;
    align-self: center;
    position: relative;
    padding: 0!important !important;
    left: 0;

    > span {
      background-color: transparent;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      border: none;
      width: 100%;
      margin-top: 0 !important;
      display: block;
      height: 29px;
      margin: 0 auto;
      cursor: pointer;
      word-break: break-all;
      padding: 0;
      color: white;
      border-radius: 7px;
      overflow-wrap: break-word;
      white-space: normal;
      line-height: 19px;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      align-self: center;
      vertical-align: middle;
      margin: auto;
      display: inline-grid;
      background-size: cover;
      background-position: center;
      cursor: pointer;
      &:before {
        cursor: pointer;
        content: "CARICA";
        font-family: Regular;
        font-weight: 300 !important;
        display: block;
        clear: both;
        text-align: center;
        height: 29px;
        width: 100%;
        border-radius: 7px;
        padding-top: 3px;
        font-size: 0.775rem !important;
        font-weight: 600;
        color: white;
        border: 3px solid #00917e;
        /*padding: .55rem .55rem !important;*/
        font-size: 0.775rem !important;
        line-height: 0.9 !important;
        border-radius: 0.1rem !important;
      }

      @media screen and (max-width: $phone) {
        margin: 0 auto!important !important;
        float: none;
      }
      @media screen and (min-width: $phone) and (max-width: $tablet) {
        margin: 0 auto!important !important;
        float: none;
      }
    }

    &:after {
      content: "";
      display: block;

      clear: both;
      text-align: center;
      width: 100%;
      font-size: 10px;
      text-decoration: underline;
      color: black;
      cursor: pointer;
      /*
      display: block;
clear: both;
text-align: center;
height: 188px;
width: 188px;
border-radius: 7px;
font-size: 10px;
text-decoration: underline;
color: black;
border: 3px solid #0e3d8b;*/

      @media screen and (max-width: $phone) {
        margin: 0 auto!important !important;
        float: none;
      }
      @media screen and (min-width: $phone) and (max-width: $tablet) {
        margin: 0 auto!important !important;
        float: none;
      }
    }

    @media screen and (max-width: $phone) {
      width: 100% !important;
      float: none !important;
      text-align: center !important;
      margin: 0 auto!important !important;
    }
    @media screen and (min-width: $phone) and (max-width: $tablet) {
      width: 100% !important;
      float: none !important;
      text-align: center !important;
      margin: 0 auto!important !important;
    }
  }
}

.niceInputLabel2 {
  color: #ffffff !important;
  font-size: 21px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 0;
  top: 0;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
  white-space: nowrap;
  overflow: hidden;
  padding-right: 0;
  text-overflow: ellipsis;
  max-width: 100%;
}

.center-container {
  display: flex;
  align-items: center;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/loadDocuments/index.vue